import { render } from "./MobileLogo.vue?vue&type=template&id=5ff4d702"
import script from "./MobileLogo.vue?vue&type=script&lang=js"
export * from "./MobileLogo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__